<template>
  <v-list
      flat
      subheader
      two-line
      max-height="35vh"
      style="overflow-y: auto"
  >
    <v-subheader>{{ $t('users.label.systemRoles') }}</v-subheader>
    <v-list-item-group v-model="selectedSystemRoles" multiple>
      <v-list-item
          v-for="(role, i) in roleSelector.groupSystemRoles"
          :key="role.rolename"
          :disabled="!rolesEditMode"
          v-show="rolesEditMode || selectedSystemRoles.indexOf(i) !== -1"
      >
        <template v-slot:default="{ active }">
          <v-list-item-action :style="rolesEditMode ? 'visibility: visible' : 'visibility: hidden'">
            <v-checkbox :input-value="active"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ ($te(`roles.all.${role.label}.label`) ? $t(`roles.all.${role.label}.label`) : role.label) + (role.groupName ? roleGroupSuffix : "") }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $te(`roles.all.${role.label}.description`) ? $t(`roles.all.${role.label}.description`) : "" }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-list-item>
    </v-list-item-group>
    <v-subheader>{{ $t('users.label.functionalRoles') }}</v-subheader>
    <v-list-item-group v-model="selectedFunctionalRoles" multiple>
      <v-list-item
          v-for="(role, i) in roleSelector.groupFunctionalRoles"
          :key="role.rolename"
          :disabled="!rolesEditMode"
          v-show="rolesEditMode || selectedFunctionalRoles.indexOf(i) !== -1"
      >
        <template v-slot:default="{ active }">
          <v-list-item-action :style="rolesEditMode ? 'visibility: visible' : 'visibility: hidden'">
            <v-checkbox :input-value="active"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $te(`roles.all.${role.label}.label`) ? $t(`roles.all.${role.label}.label`) : role.label }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $te(`roles.all.${role.label}.description`) ? $t(`roles.all.${role.label}.description`) : "" }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  props: ["target", "roleSelector", "rolesEditMode", "userGroup"], //, "roleGroupSuffix"
  data() {
    return {
      selectedSystemRoles: [],
      selectedFunctionalRoles: [],
    }
  },
  mounted() {
    if (this.target) {
      this.initCheckboxModels()
    }
  },
  watch: {
    "roleSelector.updateCounter": function () {
      this.initCheckboxModels()
    },
    target: function () {
      this.initCheckboxModels()
    },
  },
  computed: {
    roleGroupSuffix() {
      let suffix = ""
      if (this.target) {
        if (this.userGroup) { // target is a user
          suffix = " (" + this.userGroup.label + ")"
        } else if (this.target.label) { // target is a group
          suffix = " (" + this.target.label + ")"
        }
      }
      return suffix;
    }
  },
  methods: {
    initCheckboxModels() {
      this.selectedSystemRoles.splice(0, this.selectedSystemRoles.length)
      this.selectedFunctionalRoles.splice(0, this.selectedFunctionalRoles.length)
      for (const roleIndex of this.roleSelector.userSystemRoles)
        this.selectedSystemRoles.push(roleIndex)
      for (const roleIndex of this.roleSelector.userFunctionalRoles)
        this.selectedFunctionalRoles.push(roleIndex)
    },
  }
}
</script>
